import { TRACK_ENDPOINT } from './ab_track'

// 総数はサーバーが確定した値を使う。再送による重複は参考値として許容する。
export async function addReaction(action, context) {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 10000)
  try {
    const response = await fetch(TRACK_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, context }),
      signal: controller.signal,
    })
    if (response.status !== 200) throw new Error('Reaction request failed')
    const { count } = await response.json()
    if (!Number.isSafeInteger(count) || count <= 0) throw new Error('Invalid reaction count')
    document.querySelectorAll(`[data-reaction-post-id="${context.case_id ?? context.review_id}"]`)
      .forEach((element) => renderReactionCount(element, count))
    return count
  } finally {
    clearTimeout(timeout)
  }
}

export function renderReactionCount(element, count) {
  if (!element) return
  element.textContent = String(count)
  element.parentElement.hidden = count === 0
}
